require('styles/Rsvp.css');

import React from 'react'
import axios from 'axios'

const firebase = require('firebase');
require('firebase/firestore');

class Rsvp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      coming: true,
      plusOne: false,
      accomodation: false,
      message: '',
      sent: false
    };

    // this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    console.log('Sending RSVP: ', this.state);

    this.setState({
      sent: true
    })

    ga('send', 'event', 'RSVP', 'Přijde', this.state.coming ? 'ANO' : 'NE', {
      'dimension1': this.state.message,
      'dimension3': this.state.plusOne,
      'dimension4': this.state.accomodation,
      'dimension5': this.state.name
    });
    const data = {
      name: this.state.name,
      message: this.state.message,
      coming: this.state.coming,
      plusOne: this.state.plusOne,
      accomodation: this.state.accomodation
    }

    axios.post('https://us-central1-kinstovic-svatba.cloudfunctions.net/postRsvp', data).then(response => {
      console.log('Sent to API', response)
    })


    firebase.firestore().collection('rsvp').add(data).then(() => {
      Materialize.toast('Děkujeme a těšíme se na vás!', 4000);

    }).catch((error) => {
      console.error(error)
      Materialize.toast('Chyba', 4000)
      this.setState({
        sent: false
      })
    });
    event.preventDefault();
  }

  render() {
    return (
      <div className={'card ' + (this.state.sent ? 'hide' : 'show')}>
        <div className="card-content">
          <span className="card-title">Potvrzení účasti</span>


          <p>
            Prosíme Vás o včasné potvrzení Vaší účasti na obřadu i případného ubytování. Můžete k tomu využít
            následující formulář, případně nás jakkoliv jinak kontaktovat.
          </p>
          <br/>
          <form onSubmit={this.handleSubmit}>

            <div className="row">
              <div className="input-field col l8 s12">
                <input id="last_name" type="text" className="validate" value={this.state.name}
                       onChange={(event) => this.setState({name: event.target.value})}/>
                <label htmlFor="last_name">Jméno a Příjmení</label>
              </div>

              <div className="col l4 s12 checkboxes">
                <input name="coming" type="radio" id="coming" value="true" checked={this.state.coming}
                       onChange={(event) => this.setState({coming: event.target.checked})}/>
                <label htmlFor="coming">Dorazím</label>
                <br/>
                <input name="coming" type="radio" id="notComing" value="false" checked={!this.state.coming}
                       onChange={(event) => this.setState({coming: !event.target.checked})}/>
                <label htmlFor="notComing">Nemohu dorazit</label>
              </div>
            </div>

            <div className="row">
              <div className="col l6 s12">
                <input type="checkbox" className="filled-in" id="plusOne" checked={this.state.plusOne}
                       onChange={(event) => this.setState({plusOne: event.target.checked})}/>
                <label htmlFor="plusOne">Beru s sebou partnera/partnerku</label>
                <br/>
                <input type="checkbox" className="filled-in" id="accomodation" checked={this.state.accomodation}
                       onChange={(event) => this.setState({accomodation: event.target.checked})}/>
                <label htmlFor="accomodation">Chci zařídit ubytování</label>
              </div>
            </div>

            <div className="row">
              <div className="input-field col l12 s12">
                <textarea id="message" className="materialize-textarea" value={this.state.message}
                          onChange={(event) => this.setState({message: event.target.value})}/>
                <label htmlFor="message">Další sdělení</label>
              </div>
            </div>

            <div className="input-field">
              <input type="submit" className="fill btn my-green darken-3" value="Potvrdit účast"
                     disabled={this.state.name.trim() === ''}/>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

Rsvp.defaultProps = {};

export default Rsvp;



// WEBPACK FOOTER //
// ./src/components/Rsvp.js